import { UserRound } from "lucide-react";
import { imgUrl } from "@/lib/api";
import { cn } from "@/lib/utils";
import { SpineMotif } from "@/components/brand/SpineMotif";

export const ImageSlot = ({ image, label, testid, icon: Icon = UserRound, ratio = "aspect-[4/5]", className = "" }) => (
  <div data-testid={testid} className={cn("relative overflow-hidden rounded-3xl bg-gradient-to-br from-brand-tint2 via-brand-skyTint to-brand-greenTint ring-1 ring-slate-200", ratio, className)}>
    {image?.url ? (
      <img src={imgUrl(image.url)} alt={image.alt || label} loading="lazy" decoding="async" className="h-full w-full object-cover" />
    ) : (
      <div className="absolute inset-0 flex flex-col items-center justify-center gap-3 p-6 text-center" role="img" aria-label={`${label} – photo coming soon`}>
        <SpineMotif className="absolute right-5 top-5 h-2/3 text-brand-blue/10" />
        <span className="relative flex h-16 w-16 items-center justify-center rounded-full bg-white ring-1 ring-slate-200">
          <Icon className="h-7 w-7 text-brand-blue/70" aria-hidden="true" />
        </span>
        <span className="relative text-sm font-semibold text-slate-700">{label}</span>
        <span className="relative text-sm text-slate-600">Photo coming soon</span>
      </div>
    )}
  </div>
);
